package com.tfc.care.tfccare.di

import com.tfc.care.tfccare.ui.StaffChatViewModel
import org.koin.core.module.Module
import org.koin.dsl.module

expect val platformModule: Module


val appModule :Module = module{

    single { StaffChatViewModel(get(),get()) }
}